<template>
  <div style="width: 100%; padding-top: 10px; height: 100%;">
    <div style="display: grid;
        grid-template-columns: repeat(8, 1fr);
        grid-auto-rows: auto;
        gap: 8px;">

      <!-- Turnos normales -->
      <div v-for="turno in turnosConColor" :key="turno.id" :style="{
        backgroundColor: turno.color,
        padding: '16px',
        border: '1px solid #ccc',
        borderRadius: '12px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        boxSizing: 'border-box',
        gridColumn: 'span 2'
      }">
        <div>
          <div style="grid-column: span 4;">Inicio: <strong>{{ turno.hora }}</strong></div>
          <div style="grid-column: span 4;">Cliente: <strong>{{ turno.cliente }}</strong></div>
          <div style="grid-column: span 4;">Servicio: <strong>{{ turno.servicio }}</strong></div>
          <div style="grid-column: span 4;">Entrega: <strong>{{ turno.duracion }}</strong></div>
          <div style="grid-column: span 8;">Estado: <strong>{{ turno.estado }}</strong></div>
        </div>
      </div>

      <!-- Turnos con entrega -->
      <div v-for="turno in turnosEntrega" :key="turno.id" :style="{
        backgroundColor: turno.color,
        padding: '16px',
        border: '1px solid #ccc',
        borderRadius: '12px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        boxSizing: 'border-box',
        gridColumn: 'span 2'
      }">
        <div>
          <div style="grid-column: span 4;">Inicio: <strong>{{ turno.hora }}</strong></div>
          <div style="grid-column: span 4;">Cliente: <strong>{{ turno.cliente }}</strong></div>
          <div style="grid-column: span 4;">Servicio: <strong>{{ turno.servicio }}</strong></div>
          <div style="grid-column: span 4;">Entrega: <strong>{{ turno.duracion }}</strong></div>
          <div style="grid-column: span 8;">Estado: <strong>{{ turno.estado }}</strong></div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      now: moment()
    }
  },
  computed: {
    turnosConColor() {
      return this.$store.state.postventa
        .filter(turno => (turno.estado === 'PENDIENTE INGRESO') || (turno.estado === '' && !turno.duracion))
        .map(turno => {
          const entrega = moment(turno.hora, 'HH:mm');
          const diffMinutes = this.now.diff(entrega, 'minutes');
          let color = '#E8EAF6'; // Verde claro por defecto
          if (turno.estado == 'PENDIENTE INGRESO') {
            if (turno.entrega && turno.entrega.length > 0) {
              color = '#E8EAF6'; // Indigo claro (como "indigo lighten-5")
            } else if (diffMinutes > 4) {
              color = '#FFCDD2'; // Rojo claro
            } else if (diffMinutes >= -4 && diffMinutes <= 4) {
              color = '#FFF9C4'; // Amarillo claro
            }
          }
          return {
            ...turno,
            color
          };
        });
    },

    turnosEntrega() {
      return this.$store.state.postventa
        .filter(turno =>
          turno.estado !== 'PENDIENTE INGRESO' && turno.duracion && turno.duracion.length > 0
        )
        .map(turno => {
          const entrega = moment(turno.duracion, 'HH:mm');
          const diffMinutes = this.now.diff(entrega, 'minutes');

          // let color = '#C8E6C9'; // Verde claro
          let color = '#E8EAF6'; // Verde claro


          // if (turno.duracion && turno.duracion.length > 0) {
          //   color = '#E8EAF6'; // Indigo claro
          // } else if (diffMinutes > 4) {
          //   color = '#FFCDD2'; // Rojo claro
          // } else if (diffMinutes >= -4 && diffMinutes <= 4) {
          //   color = '#FFF9C4'; // Amarillo claro
          // }

          if (turno.estado === 'PARA ENTREGAR') {
            color = '#C8E6C9'
          }
          if (turno.estado === 'INGRESÓ') {
            color = '#E8EAF6'; // Indigo claro
          }

          return {
            ...turno,
            color,
            entregaMoment: entrega
          };
        })
        .sort((a, b) => a.entregaMoment.diff(b.entregaMoment));
    }
  },
  mounted() {
    const updateNow = () => {
      this.now = moment();
    };

    updateNow();

    const msToNextMinute = (60 - this.now.seconds()) * 1000;

    this.timeout = setTimeout(() => {
      updateNow();
      this.interval = setInterval(updateNow, 60000);
    }, msToNextMinute);
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
    clearInterval(this.interval);
  }
}
</script>
